import styled from 'styled-components';

export const Container = styled.div`
position: relative;
width: 100%;
padding: 4.75rem 8rem;

@media (max-width: 768px) {
    padding: 60px 40px;
    height: auto;
    overflow: contain; 
}`